import React from 'react';
import styled from 'styled-components';
import { Border, Breakpoints, Color, Grid, Type } from '../../../app/StyleGuide';
import { sanitizeHTML } from '../../../utils/sanitizeHTML';
import { Volume } from '../../curriculum';

type OverviewVolumeDetailsSectionProps = {
  volume: Pick<Volume, 'name' | 'description' | 'imageUrl' | 'posterUrl'>;
};

const VolumeDetailsSectionContainer = styled.div`
  border-radius: ${Border.radius};
`;

const VolumeDetailsSection = styled.div`
  background-color: ${Color.Gray._10};
  border-radius: ${Border.radius};
  display: flex;
  flex-direction: column;
  padding: ${Grid._4};
  h2,
  h3 {
    margin: 0;
  }
`;

const VolumeBody = styled.div`
  display: flex;
  gap: ${Grid._7};
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  h2 {
    margin-bottom: ${Grid._4};
  }
  img {
    border-radius: ${Border.radius};
    width: 100%;
  }

  @media (min-width: ${Breakpoints.screen_md}) {
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;
    img {
      width: 150px;
      height: auto;
    }
  }
`;

const VolumeImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Description = styled.div`
  p {
    font-size: ${Type.Scale._3};
  }
`;

export const OverviewVolumeDetailsSection = ({ volume }: OverviewVolumeDetailsSectionProps) => {
  const { name, description, imageUrl, posterUrl } = volume;

  return (
    <VolumeDetailsSectionContainer>
      <VolumeDetailsSection>
        <VolumeBody>
          <div>
            <h2>{name}</h2>
            <Description dangerouslySetInnerHTML={{ __html: sanitizeHTML(description ?? '') }} />
          </div>
          <VolumeImage>
            <img src={imageUrl} />
            {posterUrl && (
              <a href={posterUrl} target="_blank" rel="noreferrer noopener">
                Buy Digital Posters
              </a>
            )}
          </VolumeImage>
        </VolumeBody>
      </VolumeDetailsSection>
    </VolumeDetailsSectionContainer>
  );
};
